import React, { Component } from "react";
import __ from "lodash";
import { Bar } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

class HasilAsmMinimumProv extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listDinas: [],
            dataMahir: [],
            dataCakap: [],
            dataDasar: [],
            dataPik: [],
            obj: {},
        };
    }

    componentDidMount() {
        if (!__.isEmpty(this.props.data)) {
            const listDinas = [];
            let dataMahir = [],
                dataCakap = [],
                dataDasar = [],
                dataPik = [];
            this.props.data.map((val) => {
                listDinas.push(val.namaDisdik);
                val.mataPelajaran.map((map) => {
                    if (map.namaMataPelajaran === this.props.mapel) {
                        if (map.kategories !== undefined) {
                            map.kategories.map((d) => {
                                if (d.kategori === "Mahir") {
                                    dataMahir.push(d.persen);
                                }
                                if (d.kategori === "Cakap") {
                                    dataCakap.push(d.persen);
                                }
                                if (d.kategori === "Dasar") {
                                    dataDasar.push(d.persen);
                                }
                                if (d.kategori === "Perlu Intervensi Khusus") {
                                    dataPik.push(d.persen);
                                }
                            });
                        }
                    }
                });
            });

            this.setState({
                listDinas: listDinas,
                dataMahir: dataMahir,
                dataCakap: dataCakap,
                dataDasar: dataDasar,
                dataPik: dataPik,
            });
        }
    }

    render() {
        const data = {
            labels: this.state.listDinas,
            datasets: [
                {
                    label: "Mahir",
                    data: this.state.dataMahir,
                    backgroundColor: "rgb(255, 99, 132)",
                },
                {
                    label: "Cakap",
                    data: this.state.dataCakap,
                    backgroundColor: "rgb(75, 192, 192)",
                },
                {
                    label: "Dasar",
                    data: this.state.dataDasar,
                    backgroundColor: "rgb(255, 205, 86)",
                },
                {
                    label: "Perlu Intervensi Khusus",
                    data: this.state.dataPik,
                    backgroundColor: "rgb(54, 162, 235)",
                },
            ],
        };
        const options = {
            legend: {
                position: "bottom",
            },
            title: {
                display: true,
                text: this.props.mapel + " (dalam %)",
            },
            scales: {
                y: {
                    ticks: {
                        beginAtZero: true,
                        stacked: true,
                        steps: 10,
                        max: 100,
                    },
                },
            },
            responsive: false,
            maintainAspectRatio: true,
        };
        return <Bar data={data} options={options} width={460} height={320} />;
    }
}

export default HasilAsmMinimumProv;
